"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadService = void 0;
const restservice_1 = require("./restservice");
class DownloadService extends restservice_1.RestService {
    downloadCSVFile(tableData) {
        this.pos = 0;
        this.csvString = '';
        for (let i = 0; i < tableData.rows.length; i++) {
            this.rowData = tableData.rows[i].cells;
            for (let j = 0; j < this.rowData.length; j++) {
                if (/\s/.test(this.rowData[j].innerText)) {
                    this.rowData[j].innerText = this.rowData[j].innerText.trim();
                }
                this.csvString = this.csvString + this.rowData[j].innerText + ',';
            }
            this.csvString = this.csvString.substring(this.pos, this.csvString.length - 1);
            this.csvString = this.csvString + '\n';
        }
        this.csvString = this.csvString.substring(this.pos, this.csvString.length - 1);
        return this.csvString;
    }
}
exports.DownloadService = DownloadService;
//# sourceMappingURL=download.service.js.map